<template>
  <div class="res_main">


    <div class="res_top">
      <ul>
        <li :class="{'active': activeTab==1}"  @click="handleClick(1)">
          通过
        </li>
        <li :class="{'active': activeTab==2}"  @click="handleClick(2)">
          备选
        </li>
        <li :class="{'active': activeTab==3}"  @click="handleClick(3)">
          淘汰
        </li>
      </ul>
      <el-button type="text" @click="exportExcel">导出表格</el-button>
    </div>

    <div v-show="activeTab==1">
      <div class="res_box">
        <audition-item v-for="item in passPageProps.records"
        :key="item.id" 
        :obj="item"
       
        :id="item.id">
        </audition-item>
      </div>

      <!-- Pagination 分页 -->
      <div class="table_form_bottom">
        <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="passPageProps.total"
        :page-size="passPageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="passPageProps.pageNum"
        @size-change="handlePassSizeChange"
        @current-change="handlePassCurrentChange"
      />
      </div>
    </div>


    <div v-show="activeTab==2">
      <div class="res_box">
        <audition-item 
        v-for="item in sparePageProps.records"
        :key="item.id" 
        :obj="item"
        :id="item.id">
        </audition-item>
      </div>

      <!-- Pagination 分页 -->
      <div class="table_form_bottom">
        <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="sparePageProps.total"
        :page-size="sparePageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="sparePageProps.pageNum"
        @size-change="handleSpareSizeChange"
        @current-change="handleSpareCurrentChange"
      />
      </div>
    </div>


    <div v-show="activeTab==3">
      <div class="res_box">
        <audition-item v-for="item in outPageProps.records"
        :key="item.id" 
        :obj="item"
        :id="item.id">
        </audition-item>
      </div>

      <!-- Pagination 分页 -->
      <div class="table_form_bottom">
        <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="outPageProps.total"
        :page-size="outPageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="outPageProps.pageNum"
        @size-change="handleOutSizeChange"
        @current-change="handleOutCurrentChange"
      />
      </div>
    </div>
   
  </div>
</template>

<script>
import auditionItem from "./audition-item.vue";
import { auditList,updateAuditStatus,updateAudit,waitlist,auditResult} from "@/api/director/interview/index";

export default {
  components: { auditionItem },

  data () {
    return {
      activeTab:1,
      personList: [],
      project_id:'',
      job_id:'',

      passFormData: {
        type:'1',//1通过，2备选，3淘汰
        project_id:"",
        job_id:"",
        page: 0,
        limit: 0,
      },

      passPageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },




      spareFormData: {
        type:'2',//1通过，2备选，3淘汰
        project_id:"",
        job_id:"",
        page: 0,
        limit: 0,
      },

      sparePageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },



      outFormData: {
        type:'3',//1通过，2备选，3淘汰
        project_id:"",
        job_id:"",
        page: 0,
        limit: 0,
      },

      outPageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },

    };
  },


  watch: {
      
      // 如果只需要监听对象中的一个属性值，则可以做以下优化：使用字符串的形式监听对象属性：
        project_id: {
          // 执行方法
          handler(oldValue,newValue) {
              console.log(oldValue)
              console.log(newValue)
              if(this.project_id==""){
               // this.$message.error("请选择项目");
                return;
              }
              if(newValue){
                this.initPageProps();

                this.fetchPassData();
                this.fetchOutData();
                this.fetchSpareData();
              }
          },
  
          
          deep: true, // 深度监听
          immediate: true  // 第一次改变就执行
        },
  
        job_id: {
          // 执行方法
          handler(oldValue,newValue) {
              console.log(oldValue)
              console.log(newValue)
              if(newValue){
                this.initPageProps();

                this.fetchPassData();
                this.fetchOutData();
                this.fetchSpareData();
              }
            
          },
          deep: true, // 深度监听
          immediate: true  // 第一次改变就执行
        }
    },


  mounted() {
      if(this.project_id==""){
       // this.$message.error("请选择项目");
        return;
      }

     // this.fetchPassData();
     // this.fetchOutData();
     // this.fetchSpareData();
  },
  methods: {

    initPageProps(){

        this.sparePageProps={  
          records: [],
          total: 0,
          pageNum: 1,
          pageSize: 10};


          this.outPageProps={  
          records: [],
          total: 0,
          pageNum: 1,
          pageSize: 10};


          this.passPageProps={  
          records: [],
          total: 0,
          pageNum: 1,
          pageSize: 10};


    },

    //接收从上个页面传过来的值
    setParams(project_id,job_id){
      this.project_id=project_id;
      this.job_id=job_id;
      
    },

    fetchPassData(){
        var that = this;
        that.passFormData.page=that.passPageProps.pageNum;
        that.passFormData.limit=that.passPageProps.pageSize;
        that.passFormData.project_id=that.project_id;
        that.passFormData.job_id=that.job_id

        auditResult(that.passFormData).then((response) => {
          console.log(response);
          that.passPageProps.records = response.data.data;
          that.passPageProps.total = response.data.total;
        });
      },


      fetchSpareData(){
        var that = this;
        that.spareFormData.page=that.sparePageProps.pageNum;
        that.spareFormData.limit=that.sparePageProps.pageSize;
        that.spareFormData.project_id=that.project_id;
        that.spareFormData.job_id=that.job_id

        auditResult(that.spareFormData).then((response) => {
          console.log(response);
          that.sparePageProps.records = response.data.data;
          that.sparePageProps.total = response.data.total;
        });
      },


      fetchOutData(){
        var that = this;
        that.outFormData.page=that.outPageProps.pageNum;
        that.outFormData.limit=that.outPageProps.pageSize;
        that.outFormData.project_id=that.project_id;
        that.outFormData.job_id=that.job_id

        auditResult(that.outFormData).then((response) => {
          console.log(response);
          that.outPageProps.records = response.data.data;
          that.outPageProps.total = response.data.total;
        });
      },




     // 当前页变更
     handlePassCurrentChange(num) {
        this.passPageProps.pageNum = num
        this.fetchPassData()
      },
      // 每页显示页面数变更
      handlePassSizeChange(size) {
        this.passPageProps.pageSize = size
        this.fetchPassData()
      },



         // 当前页变更
     handleOutCurrentChange(num) {
        this.outPageProps.pageNum = num
        this.fetchOutData()
      },

      // 每页显示页面数变更
      handleOutSizeChange(size) {
        this.outPageProps.pageSize = size
        this.fetchOutData()
      },



         // 当前页变更
     handleSpareCurrentChange(num) {
        this.sparePageProps.pageNum = num
        this.fetchSpareData()
      },


      // 每页显示页面数变更
      handleSpareSizeChange(size) {
        this.sparePageProps.pageSize = size
        this.fetchSpareData()
      },


    handleClick (tab) {
      this.activeTab=tab;
    },

    exportExcel(){

    },

       //接收从上个页面传过来的值
  setParams(project_id,job_id){
      this.project_id=project_id;
      this.job_id=job_id;
    }
  },
};
</script>

<style lang="scss" scoped>
.res_main {
  border-radius: 6px;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  .res_top {
    height: 60px;
    padding: 0 27px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px #cccccc solid;
    ul {
      display: flex;
      li {
        width: 120px;
        text-align: center;
        box-sizing: border-box;
        font-size: 18px;
        line-height: 55px;
        &.active {
          border-bottom: 5px #4c71db solid;

          color: #4c71db;
        }
      }
    }
  }
}
.res_main_head {
  position: relative;
}

.res_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  min-height: 500px;
}
.table_form_bottom {
  display: flex;
  justify-content: center;
  margin: 20px;
  padding: 20px;
}
</style>